import { render, staticRenderFns } from "./mapaaproveitamentoCurso.vue?vue&type=template&id=0baa1d12&"
import script from "./mapaaproveitamentoCurso.vue?vue&type=script&lang=js&"
export * from "./mapaaproveitamentoCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports